import { OperatorGroupPermission } from '@/schema'

export const PermissionKeys = OperatorGroupPermission

export const permissionMapper: Record<string, string> = {
	MANAGE_OPERATOR: 'จัดการ operator',
	MANAGE_BANK: 'จัดการธนาคาร',
	MANAGE_PLAYER: 'จัดการผู้เล่น',
	WEB_SETTING: 'ตั้งค่าเว็บไซต์',
	MANAGE_RANK: 'จัดการระดับ',
	MANAGE_INVITE: 'จัดการการเชิญ',
	MANAGE_LUCKY_WHEEL: 'จัดการวงล้อ',
	MANAGE_DAILY_CHECK_IN: 'จัดการเช็คอินรายวัน',
	MANAGE_DEPOSIT_PROMOTION: 'จัดการโปรโมชั่น',
	MANAGE_COMMISSION_CASHBACK: 'จัดการคอมมิชชั่น',
	MANAGE_RETURN_LOSS: 'จัดการคืนยอดเสีย',
	MANAGE_MARKETING: 'จัดการการตลาด',
	MANAGE_ANNOUNCEMENT: 'จัดการประกาศ',
	MANAGE_SMS: 'จัดการ SMS',
	MANAGE_BANK_ACCOUNT: 'จัดการบัญชีธนาคาร',
	MANAGE_NOTIFICATION: 'จัดการการแจ้งเตือน',
	MANAGE_BANK_TRANSACTION: 'จัดการการทำธุรกรรม',
	MANAGE_GAME: 'จัดการการเกม',
	MANAGE_COUPON: 'จัดการคูปอง',
	MANAGE_SHOP: 'จัดการร้านค้า',
	MANAGE_TOURNAMENT: 'จัดการทัวร์นาเมนต์',
	MANAGE_BLACKLIST: 'จัดการ Blacklist',
	MANAGE_CHANNEL_ANALYTICS: 'จัดการการวิเคราะห์ช่องทาง',
	MANAGE_DOMAIN: 'จัดการการตั้งค่าโดเมน',
	MANAGE_SERVER_METRICS: 'จัดการตัวชี้วัดระบบ',
	MANAGE_CHAT: 'จัดการแชท LINE',
	MANAGE_PLAYER_TAGS: 'จัดการแท็กผู้เล่น',
	VIEW_FULL_PHONE: 'ดูเบอร์โทรฉบับเต็ม',
}

export const tagEventMapper: Record<string, string> = {
	MANAGE_OPERATOR: 'จัดการ operator',
	MANAGE_OPERATOR_GROUP: 'จัดการกลุ่ม operator',
	MANAGE_BANK: 'จัดการธนาคาร',
	MANAGE_PLAYER: 'จัดการผู้เล่น',
	MANAGE_PROMOTION: 'จัดการโปรโมชั่น',
	MANAGE_SHOP: 'จัดการร้านค้า',
	MANAGE_CHANNEL: 'จัดการช่องทาง',
	MANAGE_INVITE_FRIEND: 'จัดการการเชิญเพื่อน',
	MANAGE_PARTNER: 'จัดการพันธมิตร',
	MANAGE_PAYMENT_GATEWAY: 'จัดการเกตเวย์การชำระเงิน',
	MANAGE_COMMISSION: 'จัดการคอมมิชชั่น',
	MANAGE_RETURN_LOSS: 'จัดการคืนยอดเสีย',
	MANAGE_LUCKY_WHEEL: 'จัดการวงล้อโชคดี',
	MANAGE_DAILY_CHECK_IN: 'จัดการเช็คอินรายวัน',
	MANAGE_COUPON: 'จัดการคูปอง',
	MANAGE_RANK: 'จัดการระดับ',
	MANAGE_GENERAL_SETTING: 'จัดการการตั้งค่าทั่วไป',
	MANAGE_BANNER_SLIDE: 'จัดการแบนเนอร์สไลด์',
	MANGE_BROKE_NOTIFICATION: 'ตั้งค่าประกาศเมื่อผู้เล่นเงินหมด',
	MANAGE_LOGIN_ANNOUNCEMENT: 'จัดการประกาศเข้าสู่ระบบ',
	MANAGE_SLIDE_ANNOUNCEMENT: 'จัดการประกาศสไลด์',
	MANAGE_DYNAMIC_PAGE: 'จัดการหน้าไดนามิก',
	MANAGE_PROFILE_PAGE_BANNER: 'จัดการแบนเนอร์หน้าโปรไฟล์',
	MANAGE_GAME: 'จัดการเกม',
	MANAGE_TOURNAMENT: 'จัดการทัวร์นาเมนต์',
	MANAGE_MESSAGING: 'จัดการการส่งข้อความ',
	MANAGE_SERVER_METRICS: 'จัดการตัวชี้วัดระบบ',
	VIEW_FULL_PHONE: 'ดูเบอร์โทรฉบับเต็ม',
}

export const groupNameMapper: Record<string, string> = {
	'Promotion Manager': 'ผู้จัดการโปรโมชั่น',
	'Bank Manager': 'ผู้จัดการธนาคาร',
	Viewer: 'ผู้ดูข้อมูล',
	Admin: 'แอดมิน',
	'Super Admin': 'ซุปเปอร์แอดมิน',
}
